/** The hospital briefing: one short screen at a time, reachable from join, lobby and debrief. */
import { useState } from 'react';
import { BRIEFING } from '@nightshift/engine/client';
import { loadSeat } from '../net/api.ts';
import { navigate } from './router.ts';

export function Briefing() {
  const [i, setI] = useState(0);
  const screen = BRIEFING[i]!;
  const last = i === BRIEFING.length - 1;
  return (
    <main className="join" data-testid="briefing">
      <section className="join-card">
        <p className="muted">Screen {i + 1} of {BRIEFING.length}</p>
        <h1 className="display" data-testid="briefing-title">{screen.title}</h1>
        {screen.body.map((p) => <p key={p}>{p}</p>)}
        <div className="row">
          {i > 0 && <button className="btn" onClick={() => setI(i - 1)} data-testid="briefing-back">Back</button>}
          {!last && <button className="btn btn-primary" onClick={() => setI(i + 1)} data-testid="briefing-next">Next</button>}
          <button className="btn" onClick={() => navigate(loadSeat() ? '/play' : '/')} data-testid="briefing-close">Close</button>
        </div>
      </section>
    </main>
  );
}
